/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropusercol2Inputs */

const en_dropusercol2 = /** @type {(inputs: Dropusercol2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User`)
};

const de_dropusercol2 = /** @type {(inputs: Dropusercol2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzer`)
};

/**
* | output |
* | --- |
* | "User" |
*
* @param {Dropusercol2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropusercol2 = /** @type {((inputs?: Dropusercol2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropusercol2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropusercol2(inputs)
	return de_dropusercol2(inputs)
});
export { dropusercol2 as "dropUserCol" }